import { Evidence } from '@/@types/Evidence';
import { EvidenceCardProps } from '@/components/table/EvidenceCard';
import { getCurrentThread } from '@/store/reducers/UIState';
import { getEvidence } from '@/api/ChatApi';
import { MULTI_TOOL, TABLE_ANNOTATION } from 'configs/NoraVariants';
import { openReaderWidget } from '@/store/actionCreators/WidgetActions';
import { optAppConfig } from '@/utils/config';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

import { Button, Typography } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';

const noraExperienceVariant = optAppConfig((_) => _.experience.variant);

export const EvidenceCardContent = (props: EvidenceCardProps): ReactNode => {
  const dispatch = useAppDispatch();
  const currentThread = useAppSelector(getCurrentThread);
  const [loading, setLoading] = useState<boolean>(false);
  const [evidences, setEvidences] = useState<Evidence[] | null>(null);
  const [corpusId, setCorpusId] = useState<number | null>(null);

  useEffect(() => {
    // If evidence data is provided, use it directly
    console.log('PROPS', props);
    if ('evidences' in props) {
      setEvidences(props.evidences);
      return;
    }
    // If only an evidence id is provided, fetch evidence data
    setLoading(true);
    getEvidence(props.evidenceId)
      .then((data) => {
        setCorpusId(data.corpusId);
        setEvidences(data.supports);
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props]);

  const handleShowInPaper = (evidence: Evidence) => {
    if (!currentThread) {
      console.error('No current thread');
      return;
    }
    if (!corpusId) {
      console.error('No corpusId');
      return;
    }
    if (!evidence.bboxs) {
      console.error('No bboxs');
    }
    dispatch(
      openReaderWidget({
        currentThreadId: currentThread.id,
        corpusId,
        highlights: evidence.bboxs,
      }),
    );
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading...</div>;
  } else if (!evidences) {
    return <div style={{ padding: '20px' }}>No data.</div>;
  }
  return (
    <>
      {evidences.map((evidence, index) => (
        <EvidenceContainer key={index}>
          <Typography sx={{ mb: 1.5 }} variant="body2">
            {`“${evidence.text}”`}
          </Typography>

          {(noraExperienceVariant === MULTI_TOOL ||
            noraExperienceVariant === TABLE_ANNOTATION) &&
            evidence.bboxs && (
              <ButtonContainer>
                <Button
                  onClick={() => handleShowInPaper(evidence)}
                  variant="outlined"
                  size="small"
                >
                  Show in Paper
                </Button>
              </ButtonContainer>
            )}
        </EvidenceContainer>
      ))}
    </>
  );
};

const ButtonContainer = styled.div`
  width: 100%;
  margin-bottom: 10px;
  text-align: right;
`;

const EvidenceContainer = styled.div`
  margin-top: 8px;
`;
